module.exports = __webpack_public_path__ + "static/media/20ECE24.a71fa74f.jpg";